export default __webpack_public_path__ + "static/media/middle.916b915b.png";